import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css";
import "./index.css";
import App from "./App";
import { AppProviders } from "./app/providers/AppProviders";
import {
  clearIdentityOwnedFrontendState,
  clearRevokedIdentityOwnedFrontendState,
} from "./app/providers/clearIdentityOwnedFrontendState";
import {
  claimCandidatePaymentCallbackCredential,
  reconcileCandidateIdentityOwnedFrontendState,
} from "./app/providers/reconcileCandidateIdentityOwnedFrontendState";
import { ErrorBoundary } from "./app/errors/ErrorBoundary";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AppProviders
          claimCandidatePaymentCallbackCredential={
            claimCandidatePaymentCallbackCredential
          }
          clearIdentityOwnedState={clearIdentityOwnedFrontendState}
          clearRevokedIdentityOwnedState={
            clearRevokedIdentityOwnedFrontendState
          }
          reconcileCandidateIdentityOwnedState={
            reconcileCandidateIdentityOwnedFrontendState
          }
        >
          <App />
        </AppProviders>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
